import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

function AddNewTechnical() {
    const { cogen_id } = useParams(); // Extracting from URL

    const [formData, setFormData] = useState({
        boilerMake: '',
        boilerPressure: '',
        boilerTemperature: '',
        boilerCapacity: '',
        furnaceType: '',
        fuel: '',
        turbineMake: '',
        turbineCapacity: '',
        plantMake: ''
    });

    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isEntryExists, setIsEntryExists] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isAllowed, setIsAllowed] = useState(false);

    // Check if cogen_id entry already exists
    useEffect(() => {
        const checkEntry = async () => {
            try {
                const res = await axios.get(`https://backend-zkgn.onrender.com/api/cogen_technical/check/${cogen_id}`);
                if (!res.data.exists) {
                    setIsAllowed(true);
                } else {
                    setErrorMessage('Technical info already exists for this Cogen ID.');
                }
                setIsEntryExists(res.data.exists);
            } catch (error) {
                console.error('Error checking technical entry:', error);
                setErrorMessage('Failed to check existing technical entry.');
            } finally {
                setLoading(false);
            }
        };

        if (cogen_id) checkEntry();
    }, [cogen_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validate = () => {
        let tempErrors = {};
        let isValid = true;

        Object.entries(formData).forEach(([key, value]) => {
            if (!value.trim()) {
                tempErrors[key] = `${key} is required.`;
                isValid = false;
            }
        });

        setErrors(tempErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) return;

        try {
            const response = await axios.post('https://backend-zkgn.onrender.com/api/cogen_technical', {
                cogen_id: parseInt(cogen_id),
                boiler_make: formData.boilerMake,
                boiler_pressure: formData.boilerPressure,
                boiler_temperature: formData.boilerTemperature,
                boiler_capacity: formData.boilerCapacity,
                furnes_type: formData.furnaceType,
                fuel: formData.fuel,
                turbine_make: formData.turbineMake,
                turbine_capacity: formData.turbineCapacity,
                cogen_plant_make: formData.plantMake
            });

            if (response.status === 201) {
                setSuccessMessage('Technical Information Added Successfully!');
                setErrorMessage('');
                setFormData({
                    boilerMake: '',
                    boilerPressure: '',
                    boilerTemperature: '',
                    boilerCapacity: '',
                    furnaceType: '',
                    fuel: '',
                    turbineMake: '',
                    turbineCapacity: '',
                    plantMake: ''
                });
            }
        } catch (error) {
            console.error(error);
            if (error.response?.data?.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('Submission failed. Try again.');
            }
        }
    };

    if (loading) return <div className="text-center mt-5">Checking entry for Cogen ID...</div>;

if (!isAllowed) {
    return (
        <div className="container mt-5 text-center">
            <div className="alert alert-danger">{errorMessage}</div>
            <a href="/" className="btn btn-secondary mt-3">Go Back</a>
        </div>
    );
}

    return (
        <div className="container my-5">
            <h4 className="mb-4 text-center">Add Technical Information</h4>

            {isEntryExists ? (
                <div className="alert alert-warning text-center">
                    Technical information for <strong>cogen_id {cogen_id}</strong> already exists.
                </div>
            ) : (
                <>
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

                    <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
                        <div className="row g-3">
                            {[
                                { name: 'boilerMake', label: 'Boiler Make' },
                                { name: 'boilerPressure', label: 'Boiler Pressure' },
                                { name: 'boilerTemperature', label: 'Boiler Temperature' },
                                { name: 'boilerCapacity', label: 'Boiler Capacity' },
                                { name: 'furnaceType', label: 'Furnace Type' },
                                { name: 'fuel', label: 'Fuel' },
                                { name: 'turbineMake', label: 'Turbine Make' },
                                { name: 'turbineCapacity', label: 'Turbine Capacity' },
                                { name: 'plantMake', label: 'Cogen Plant Make' }
                            ].map((field, index) => (
                                <div className="col-md-6" key={index}>
                                    <label className="form-label">{field.label}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={field.name}
                                        value={formData[field.name]}
                                        onChange={handleChange}
                                    />
                                    {errors[field.name] && <small className="text-danger">{errors[field.name]}</small>}
                                </div>
                            ))}
                        </div>

                        <div className="text-center mt-4">
                            <button type="submit" className="btn btn-primary px-4">Submit</button>
                        </div>
                    </form>
                </>
            )}
        </div>
    );
}

export default AddNewTechnical;
